import React from 'react';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Add as AddIcon } from '@mui/icons-material';

interface ConfigSectionProps {
  title: string;
  addLabel: string;
  rows: { id: string }[];
  columns: GridColDef[];
  /** False until a config has been read back from the server, which disables Add. */
  canEdit: boolean;
  onAdd: () => void;
  sx?: Record<string, unknown>;
}

/** One titled grid of config entries. Rendered once for updates and once for coming soon. */
const ConfigSection: React.FC<ConfigSectionProps> = ({
  title,
  addLabel,
  rows,
  columns,
  canEdit,
  onAdd,
  sx
}) => (
  <Paper sx={{ p: 2, ...sx }} variant='outlined'>
    <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ mb: 1 }}>
      <Typography variant='subtitle1'>
        {title} ({rows.length})
      </Typography>
      <Button size='small' startIcon={<AddIcon />} onClick={onAdd} disabled={!canEdit}>
        {addLabel}
      </Button>
    </Stack>
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={row => row.id}
      autoHeight
      disableSelectionOnClick
      hideFooterSelectedRowCount
      pageSize={10}
      rowsPerPageOptions={[10, 25, 50]}
    />
  </Paper>
);

ConfigSection.defaultProps = {
  sx: {}
};

export default ConfigSection;
